import React from 'react';
import team1 from '../../assets/teams/Founder.webp';
import team2 from '../../assets/teams/CEO.webp';
import team3 from '../../assets/teams/CFO.webp';
import team4 from '../../assets/teams/COO.webp';
import team5 from '../../assets/teams/image5.jpg';
import team6 from '../../assets/teams/image6.jpg';
import team7 from '../../assets/teams/image7.jpg';
import team8 from '../../assets/teams/image8.jpg';

const OurTeam = () => {
  const teamMembers = [
    {
      id: 1,
      name: 'Prince G. Sunuwar',
      role: 'Founder & Creative Director',
      image: team1,
    },
    {
      id: 2,
      name: 'Krishna G. Mul',
      role: 'CEO & Co-founder',
      image: team3,
    },
    {
      id: 3,
      name: 'Rojan G. Mul',
      role: 'CTO & Co-founder',
      image: team2,
    },
    {
      id: 4,
      name: 'Shyam G. Mul',
      role: 'Marketing Director',
      image: team4,
    },
    {
      id: 5,
      name: 'Rahul Khadgi',
      role: 'Creative Designer',
      image: team6,
    },
    {
      id: 6,
      name: 'Ronel Balami',
      role: 'Concept Designer',
      image: team5,
    },
    {
      id: 7,
      name: 'Agni K. Chhetri',
      role: 'Graphic Designer',
      image: team7,
    },
    {
      id: 8,
      name: 'Dawa Theeng',
      role: 'Creative Designer',
      image: team8,
    },
  ];

  return (
    <main className="w-full bg-black py-16 text-white">
      <div className="lg:w-10/12 md:w-11/12 w-11/12 mx-auto">
        <div className="text-center">
          <h1 className="lg:text-6xl md:text-4xl text-3xl font-bold" data-aos="fade-up">
            Meet Our{' '}
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#E10B7B] via-[#652D90] to-[#1C85C7] animate-bounce">
              Team
            </span>
          </h1>
          <h2 className="text-white pt-4">
            LogoLab Nepal offers top logo design services, creating unique logos to elevate your brand
          </h2>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 mt-12 mx-8">
        {teamMembers.map((member, index) => (
          <div
            key={member.id}
            className={`border-1 border-dashed border-gray-700 text-center transition duration-300 w-full max-w-full p-6 hover:shadow-lg 
            ${index < 4 ? 'border-b-0' : ''} 
            ${index % 4 !== 3 ? 'border-r-0' : ''}`}
          >
            <img
              src={member.image}
              alt={member.name}
              className="bg-black lg:h-[55vh] lg:w-[45vh] h-[40vh] w-full object-cover mx-auto grayscale hover:contrast-125 transition-all duration-300"
            />
            <h1 className="text-lg mt-4 font-bold cursor-pointer">{member.name}</h1>
            <p className="font-light cursor-pointer">
              <i>{member.role}</i>
            </p>
          </div>
        ))}
      </div>
    </main>
  );
};

export default OurTeam;
